import HorizontalThumbnail from "../HorizontalThumbnail";
import React from "react";

export interface RelatedPostProps {
  title: string;
  subtitle: string;
  link: string;
  image?: string;
  cover?: string;
}

export interface RelatedPostsWidgetProps {
  header?: string;
  items?: RelatedPostProps[];
  limit?: number;
}

const RelatedPostsWidget = ({
  header,
  items,
  limit = 4,
}: RelatedPostsWidgetProps) => {
  return (
    <div className="space-y-2">
      <div className="text-lg font-medium text-aqua">
        {header || "Related Posts"}
      </div>
      <div className="flex flex-wrap space-y-8">
        {items && items.length ? (
          items.slice(0, limit).map((item, key) => (
            <div className="w-full" key={key}>
              <div className="mr-4">
                <HorizontalThumbnail
                  title={item.title}
                  subtitle={item.subtitle}
                  link={item.link}
                  image={item.image}
                  cover={item.cover}
                />
              </div>
            </div>
          ))
        ) : (
          <div className="w-full p-4 my-2 text-sm text-center text-gray-400 bg-gray-100 rounded">
            No sessions available.
          </div>
        )}
      </div>
    </div>
  );
};

export default RelatedPostsWidget;
